import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e14952a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "league-container" }
const _hoisted_2 = { class: "left animate__lightSpeedInLeft wow" }
const _hoisted_3 = { class: "left-top" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "left-btm" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "right animate__lightSpeedInRight wow" }, null, -1))

import WOW from 'wowjs'
import { onMounted } from "vue"

export default /*#__PURE__*/_defineComponent({
  __name: 'leagueView',
  setup(__props) {

onMounted(() => {
  new WOW.WOW(
    { live: false }
  ).init()

})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('leaguetitle')), 1),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('leaguesubtitle')), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h2", null, "\"" + _toDisplayString(_ctx.$t('leagueact1')) + "\"", 1),
        _createElementVNode("div", null, _toDisplayString(_ctx.$t('leagupoem')), 1),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('leagutext')), 1)
      ])
    ]),
    _hoisted_6
  ]))
}
}

})